import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';
import './GoogleAuth.css';

const GoogleAuth: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();

  const initiateGoogleAuth = async () => {
    try {
      const { url } = await api.getGoogleAuthUrl();
      window.location.href = url;
    } catch (error) {
      console.error('Failed to get Google auth URL:', error);
      alert('Failed to initiate Google sign-in. Please try again.');
      navigate('/');
    }
  };

  useEffect(() => {
    const code = searchParams.get('code');
    
    if (code) {
      // Handle OAuth callback
      handleCallback(code);
    } else {
      // Redirect to Google OAuth
      initiateGoogleAuth();
    }
    // handleCallback and initiateGoogleAuth are stable within this component
    // and we only depend on the current search params.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const handleCallback = async (code: string) => {
    try {
      const { token } = await api.handleGoogleCallback(code);
      login(token);
      navigate('/dashboard');
    } catch (error) {
      console.error('Failed to handle Google callback:', error);
      alert('Failed to complete sign-in. Please try again.');
      navigate('/');
    }
  };

  return (
    <div className="google-auth-container">
      <div className="auth-loading">
        <div className="spinner"></div>
        <p>Signing in with Google...</p>
      </div>
    </div>
  );
};

export default GoogleAuth;

